export default __webpack_public_path__ + "static/logo_navbar-7f48f9bc8f6f98d178e309640fae66b1.png";